<template>
	<!-- Returns objects, multiple selection is possible, displays chips -->
	<!-- EXAMPLE USE
		<autocomplete
			:items="formItems.mandator"
			label="Mandator"
			:model="formState.selectedMandators"
		>
		</autocomplete>
	-->
	<!-- IMPORTANT! the modelEmit event is to be taken care about in the parent component -->
	<!--
		the shown text parameter can ba passed into this component,
		default is "text" (will work automatically for objects with params "text" and "value")
	-->
	<div>
		<v-autocomplete
			v-show="show"
			v-model="modelLocal"
			hide-selected
			persistent-hint
			chips
			return-object
			:clearable="clearable"
			:items="items"
			:itemText="getItemText()"
			:key="keyIndexLocal"
			:error-count="errorCount"
			:error-messages="errorMessage"
			:search-input.sync="searchLocal"
			:label="label"
			:multiple="!solo"
			:solo="solo"
			:disabled="disabled"
			:selectAllChekced="selectAllChecked"
			:hint="hintLocal"
			:filter="filterRegex"
			@keypress="keyPressHandler"
			@change="selectedValueEmit"
		/>
	</div>
</template>

<script>
export default {
	name: 'AutocompleteBasicWithEmits',
	props: {
		show: {
			type: Boolean,
			default: true,
		},
		model: {
			type: Array,
			required: true,
		},
		items: {
			tpye: Array,
			required: true,
			default: ['could not be loaded'],
		},
		label: {
			type: String,
			required: true,
		},
		errorCount: {
			type: Number,
			default: 0,
		},
		errorMessage: {
			type: String,
			default: '',
		},
		search: {
			default: null,
		},
		solo: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		keyIndex: {
			type: Number,
			default: 0,
		},
		selectAllChecked: {
			type: Boolean,
			default: false,
		},
		wildcardUsage: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
		groupingEffect: {
			type: Boolean,
			default: false,
		},
		itemText: {
			required: false,
		},
		compositeItemText: {
			type: Array,
			required: false,
		},
	},
	data() {
		return {
			modelLocal: this.model,
			searchLocal: this.search,
			keyIndexLocal: this.keyIndex,
			txt: {
				hint: {
					grouping: 'The filter will group results.',
					selectedAll: 'Selected all items.',
				},
			},
		}
	},
	methods: {
		selectedValueEmit() {
			this.$emit('modelEmit', this.modelLocal)
			this.$emit('searchEmit', this.searchLocal)
		},
		makeRegexString(inputText) {
			// replace all dots so regex does not see them as any character literal
			let regexString = inputText.replace(/\./g, '\\.')
			// replace all stars to match any letter or number one or more times (+)
			regexString = regexString.replace(/\*/g, '[A-Z0-9_]+')
			return regexString
		},
		filterRegex(item, inputText) {
			const regexString = this.makeRegexString(inputText)
			try {
				const regex = new RegExp(regexString, 'i')
				if (this.itemText) return regex.test(item[this.itemText])
				return regex.test(item.text)
			} catch (err) {
				return false
			}
		},
		keyPressHandler(event) {
			if (this.wildcardUsage && event.key == 'Enter') {
				// eslint-disable-next-line no-underscore-dangle
				const textFieldInput = event.target._value
				const regexString = new RegExp(this.makeRegexString(textFieldInput), 'i')
				this.modelLocal = this.items.filter((el) => regexString.test(el.text))
				this.$emit('modelEmit', this.modelLocal)
			}
		},
		getItemText() {
			if (this.itemText) {
				return (item) => item[this.itemText]
			}
			if (this.compositeItemText) {
				return (item) => this.compositeItemText.map((key) => item[key]).join(' ')
			}
			return (item) => item['text'] // Default is "text"
		},

	},
	computed: {
		hintLocal() {
			let message = ''
			// if the filter has goruing effect regarding the results
			if (this.groupingEffect && (this.modelLocal.length > 0 || this.selectAllChecked)) {
				message = this.txt.hint.grouping
			}
			// if all items are seleted
			if (this.selectAllChecked) return message + this.txt.hint.selectedAll
			if (!this.selectAllChecked)	return message
			return ''
		},
	},
	watch: {
		keyIndex: {
			handler() {
				// force the update only if in the parent component a select all action was triggered
				// -> do not show any chip in the field
				if (this.selectAllChecked && this.modelLocal.length !== 0) {
					this.modelLocal = []
					this.keyIndexLocal = this.keyIndex
				}
				// clear the modelLocal if the parent has been cleared already
				// to - avoid selected value collision on mandator change
				if (this.modelLocal.length !== this.model.length && this.model.length == 0) this.modelLocal = []
			},
		},
	},
}
</script>

<style>

</style>
